export const SETTINGS_TABS = {
  profile: "profile",
  team: "team",
  concierge: "concierge",
  campaign: "campaign",
  session: "session",
  crmSettings: "crm",
  phoneSms: "phone_sms",
  configureEmail: "email",
  acuityCalendar: "acuity_calendar",
  planBilling: "plan_billing",
}

/**
 * Tabs that were folded into another page. Old links (emails, bookmarks,
 * Stripe/Zoho return URLs) still carry these values.
 */
export const LEGACY_SETTINGS_TABS = {
  inbox: "inbox",
  billing: "billing",
  invoices: "invoices",
  mlsPurchaseHistory: "mls_purchases",
  subscription: "sub",
}

/** Section ids on the Plan & billing page, matching the old tab values. */
export const PLAN_BILLING_SECTIONS = {
  subscription: LEGACY_SETTINGS_TABS.subscription,
  paymentMethod: LEGACY_SETTINGS_TABS.billing,
  invoices: LEGACY_SETTINGS_TABS.invoices,
  mlsPurchases: LEGACY_SETTINGS_TABS.mlsPurchaseHistory,
}

const LEGACY_BILLING_TABS = new Set([
  LEGACY_SETTINGS_TABS.billing,
  LEGACY_SETTINGS_TABS.invoices,
  LEGACY_SETTINGS_TABS.mlsPurchaseHistory,
  LEGACY_SETTINGS_TABS.subscription,
])

/**
 * Where an old `/settings?tab=` link should go now, or null when the URL is
 * current. Other query params (thread, channel, ...) are carried over.
 */
export function getLegacySettingsRedirect(search) {
  const params = new URLSearchParams(search || "")
  const tab = params.get("tab")
  if (tab === LEGACY_SETTINGS_TABS.inbox) {
    params.delete("tab")
    const rest = params.toString()
    return rest ? `/messages?${rest}` : "/messages"
  }
  if (LEGACY_BILLING_TABS.has(tab)) {
    params.set("tab", SETTINGS_TABS.planBilling)
    params.set("section", tab)
    return `/settings?${params.toString()}`
  }
  return null
}

/** Link to one section of the Plan & billing page. */
export function createPlanBillingURL(section) {
  return createSettingsTabURL(SETTINGS_TABS.planBilling, { section })
}

export function createSettingsTabURL(tab, extraParams) {
  const params = new URLSearchParams({ tab })
  if (extraParams) {
    for (const [key, value] of Object.entries(extraParams)) {
      if (value != null && value !== "") {
        params.set(key, String(value))
      }
    }
  }
  return `/settings?${params.toString()}`
}
